import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT } from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";
import { DateUtil } from '../../../util/DateUtil';
import { DATE_FORMAT, MIME_TYPE } from '../../../constants/constants';
import { DocumentPreview } from '../../viewDocument/DocumentPreview';
import { LoadingUtil } from '../../../util/LoadingUtil';
import { EnvConstants } from '../../../EnvConstants';
import { DonwloadUtil } from '../../../util/DonwloadUtil';
import { UserUtil } from '../../../util/UserUtil';

export class SolicitudesAsignadasAdminPage extends BasePage {

  createPageProperties = (pageApi) => {
    return {
      title: 'SOLICITUDES ASIGNADAS'
    };
  }

  renderPage(pageApi) {
    const getGridSoli_asignadas = () => pageApi.getComponent('grid');
    const getFormSoli_asignadas = () => pageApi.getComponent('form');

    const DocumentPreviewModal = (data) => {
      return {
        width: 950,
        maskClosable: true,
        closable: false,
        component: <DocumentPreview name={data} getParentApi={pageApi.getApi} />
      }
    };

    const formSoli_asignadasConfig = {
      layout: 'vertical',
      fields: [
        { name: 'doc_nro', label: 'Nro. Solicitud:', column: 2 },
        { type: 'select', name: 'id_empresa', label: 'Empresa', column: 6, load: { queryId: 65 }, search: true },
        { type: 'date', name: 'fecha_desde', label: 'Desde', column: 2, value: DateUtil.getDate2(15), format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD },
        { type: 'date', name: 'fecha_hasta', label: 'Hasta', column: 2, value: DateUtil.getDate, format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD },
      ]
    };

    const gridSoli_asignadasConfig = {
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      load: {
        queryId: 875,
        hideMessage: true,
        hideMessageError: true,
        params: {
          id_user: UserUtil.getUserId(),
          fecha_desde: DateUtil.getDate2(15),
          fecha_hasta: DateUtil.getDate
        }
      },
      fields: [
        { name: 'servicio', label: 'Tipo Servicio' },
        { name: 'doc_nro_ss', label: 'Nro Solicitud' },
        { name: 'empresa', label: 'Cliente' },
        { name: 'fecha_aprobacion_servicio', label: 'F. Aprob. Servicio' },
        { name: 'fecha_servicio', label: 'Fecha Inicio Servicio' },
        { name: 'fecha_final', label: 'Fecha Fin Servicio' },
        {
          ...COLUMN_DEFAULT.EDIT, label: 'Opciones', colSpan: 6, title: 'Listado de cadenas', color: 'blue',
          link: (value, row, index) => `/solicitudes-asignadas/solicitudes-asignadas/${row.id_doc}`,
        },
        {
          ...COLUMN_DEFAULT.PDF, title: 'Visualizar Solicitud Aprobada', color: 'black', colSpan: 0, onClick: (value, row, index) => {
            LoadingUtil.loadShow();
            let url = EnvConstants.GET_REPORT2_URL() + 'SolicitudMa_aprobada';
            DonwloadUtil.donwloadBlob(url, { params: { id_doc: row.id_doc ,es_ejecutado: 0,nuevo_formato: row.nuevo_formato} }, "Solicitud_Servicio_" + row.doc_nro_ss + ".pdf").then(x => {

              var reader = new FileReader();
              reader.readAsDataURL(x.blob);
              reader.onloadend = function () {
                var base64data = reader.result;
                let obj = {
                  url: base64data,
                  type_file: MIME_TYPE.pdf
                }
                pageApi.showModal(DocumentPreviewModal(obj));
                LoadingUtil.loadHide();
              }
            }).catch(x => {
              console.error(x)
              LoadingUtil.loadHide();
            });
          },

        },
      ]
    };

    const barButtonSoli_asignadasconfig = {
      fields: [
        { ...BUTTON_DEFAULT.SEARCH, onClick: () => getGridSoli_asignadas().load({ params: getFormSoli_asignadas().getData() }) },
        { ...BUTTON_DEFAULT.CLEAR1, onClick: () => getFormSoli_asignadas().reset() },
      ]
    }

    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formSoli_asignadasConfig}
        />
        <BarButtonFw
          name="bar"
          getParentApi={pageApi.getApi}
          config={barButtonSoli_asignadasconfig}
        />
        <GridFw
          name="grid"
          getParentApi={pageApi.getApi}
          config={gridSoli_asignadasConfig}
        />
      </>
    )
  }
}
